var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"logo-container"},[_c('img',{attrs:{"src":require("../../../assets/images/logo-2.png"),"alt":""},on:{"click":_vm.goHome}})]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-container"},[_c('h4',[_vm._v("欢迎来到 留言管理中心 !")])])
}]

export { render, staticRenderFns }